<template>
    <div class="">

        <Banner :background="(item.image) ? item.image : ''"
            :title="(!pgLoading) ? ($i18n.locale == 'en') ? item.en.title : item.ar.title : ''">
        </Banner>

        <WhoWeAre></WhoWeAre>
        <OurValues></OurValues>
        <OurMission></OurMission>
        <OurTeam></OurTeam>
    </div>
</template>

<script>
export default {
    name: 'List',
    components: {
        Banner: () => import("@/components/Banner.vue"),
        WhoWeAre: () => import("@/components/WhoWeAre.vue"),
        OurValues: () => import("@/components/OurValues.vue"),
        OurMission: () => import("@/components/OurMission.vue"),
        OurTeam: () => import("@/components/OurTeam.vue"),
    },
    data() {
        return {
            //
            item: '',
            refs: 'pages',
            pgLoading: true,
        }
    },
    mounted() { },
    created() {
        //
        this.fetchData();
    },
    methods: {
        //
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/' + this.refs,
                method: 'GET',
                data: {},
                headers: {
                    appId: process.env.VUE_APP_APPID
                }
            }
            this.axios(options)
                .then(res => {
                    this.pgLoading = false;
                    this.item = res.data.data.row;
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
